import { Box, Tooltip, Typography } from '@mui/material';

interface DepartureProvenanceNoteProps {
  count: number;
  color: string;
  testId: string;
  note: (count: number) => string;
  explanation: string;
}

/**
 * One line saying how many of this year's exits the app worked out rather
 * than read from the roster, with the method behind a tooltip. Two notes
 * share it: absence-derived exits and dated exits classified from scores.
 */
export function DepartureProvenanceNote({
  count,
  color,
  testId,
  note,
  explanation,
}: DepartureProvenanceNoteProps) {
  if (count <= 0) {
    return null;
  }
  return (
    <Box data-testid={testId} sx={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
      <Typography component="span" sx={{ fontSize: 12, lineHeight: '16px', fontWeight: 500, color }}>
        {note(count)}
      </Typography>
      <Tooltip title={explanation} describeChild enterTouchDelay={0} leaveTouchDelay={8000}>
        <Typography
          component="button"
          type="button"
          sx={{
            p: 0,
            border: 0,
            background: 'none',
            cursor: 'pointer',
            font: 'inherit',
            fontSize: 12,
            lineHeight: '16px',
            fontWeight: 600,
            color,
            textDecoration: 'underline',
          }}
        >
          How was this calculated?
        </Typography>
      </Tooltip>
    </Box>
  );
}
